// Localized Swiper accessibility labels (strings set in layout/theme.liquid as window.themeA11yStrings).
// Loaded right after swiper-bundle.min.js so the defaults apply to every slider on the page.
;(function () {
	const strings = window.themeA11yStrings
	if (!strings || !window.Swiper || typeof window.Swiper.extendDefaults !== 'function') return
	window.Swiper.extendDefaults({
		a11y: {
			prevSlideMessage: strings.prevSlide,
			nextSlideMessage: strings.nextSlide,
			firstSlideMessage: strings.firstSlide,
			lastSlideMessage: strings.lastSlide,
			paginationBulletMessage: strings.goToSlide.replace('[index]', '{{index}}'),
		},
	})
})()
